module.exports = __webpack_public_path__ + "media/fail.eaed7ab8.mp3";